import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Checkbox, Flex, Input, Form, message, Space, Popover } from "antd";
import { login, loginByPhone, sendSmsCode, getBindEmailCode, getPhoneVerifyCode, resetPhonePassword, resetEmailPassword } from '@/apis/login';
import { DataContext } from "@/context";
// import LOGIN_LOGO from "@/assets/images/login/login_logo.png";
import QR_CODE from "@/assets/images/login/qrcode.jpg";
import EyePng from "@/assets/images/login/eye.png";
import HideEyePng from "@/assets/images/login/hide_eye.png";
// import { recordClickType } from "@/apis/record";
// import { clickTypeMapper } from '@/config/constent';
import { usePostHog } from 'posthog-js/react';
import { recordEventRecord } from '@/apis/record';

const LOGIN_LOGO = 'https://ps-cdn.cemeta.cn/configs/frontend/20250917/3.png'
interface Props {
  open: Boolean;
  propsSetOpen?: (value: boolean) => any;
  propsSetIsLogin?: (value: string) => any;
}

const formItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 24,
    },
  },
};

const ForgetPassword: React.FC<Props> = (props: Props) => {
  const { open, propsSetOpen, propsSetIsLogin } = props;
  const timer = useRef(0);
  const {
    userInfo,
    setContextValue
  } = useContext(DataContext);

  const searchParamsString = window.location.href.split('?')[1] || '';
  const searchParams = new URLSearchParams(searchParamsString);

  const [messageApi, contextHolder] = message.useMessage();

  const [form] = Form.useForm();
  const [submittable, setSubmittable] = React.useState(true);
  const [loginType, setLoginType] = useState<'phone_number' | 'email'>('email');
  const [isPassword, setIsPassword] = useState(true)
  const [countDown, setCountDown] = useState(60);

  const isPhoneLogin = loginType === 'phone_number';
  const isEmailLogin = loginType === 'email';

  const values = Form.useWatch([], form);

  const posthog = usePostHog();

  useEffect(() => {
    if (!(userInfo?.user_id === 0 || userInfo?.user_id) && open) {
      const userForm = localStorage.getItem('userLogin')

      if (userForm) {
        form.setFieldsValue(JSON.parse(userForm))
      }
    }
}, [open, userInfo?.user_id])

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then((res) => {
        setSubmittable(true)
      })
      .catch((err) => {
        // console.log(err)
        if (err?.errorFields?.length) {
          setSubmittable(false)
        }
      });
  }, [form, values]);

    const jumpLogin = (e) => {
    e.preventDefault();
    propsSetIsLogin?.('login');
  };

  const jumpRegister = (e) => {
    e.preventDefault();
    propsSetIsLogin?.('register');
  };

  const handleLogin = async () => {
    const {...values} = await form.getFieldsValue();
    // console.log(123, values)

    // 看后面的接口是否是同一个，暂定是同一个
    if (!isPhoneLogin) {
      values.phone_number = undefined;
      
      await resetEmailPassword({
          email: values?.email,
          verify_code: values?.verify_code,
          new_password: values?.password
      }).then(() => {
          messageApi.open({
            type: 'success',
            content: '密码重置成功！',
          });
          propsSetIsLogin?.('login');
      }).catch((e) => {
        console.log(e)
        messageApi.open({
          type: 'error',
          content: e,
        });
      })
    } else {
      values.email = undefined;
      await resetPhonePassword({
          phone_number: values?.phone_number,
          country_code: '+86',
          verify_code: values?.verify_code,
          new_password: values?.password
      }).then(() => {
          messageApi.open({
            type: 'success',
            content: '密码重置成功！',
          });
          propsSetIsLogin?.('login');
      }).catch((e) => {
        console.log(e)
        messageApi.open({
          type: 'error',
          content: e,
        });
      })
    }
   
  }

  const timeCountDown = () => {
    setCountDown(countDown - 1)
  }

  useEffect(() => {
    if (countDown !== 60) {
      timer.current = window.setTimeout(() => {
        if (countDown <= 0) {
          timer.current && clearTimeout(timer.current)
          setCountDown(60)
        } else {
          setCountDown(countDown - 1)
        }
      }, 1000)
    }
    return () => {
      timer.current && clearInterval(timer.current)
    }
  }, [countDown])

  const handleVerifyCode = () => {
    if (countDown !== 60) {
      messageApi.open({
        type: 'warning',
        content: `${countDown} + '秒后再试'`,
      });
      return
    }
    if (isEmailLogin) {
      form.validateFields(['email'])
        .then(async () => {
          await getBindEmailCode({ email: values.email, code_type: 'reset' })
            .then(() => {
              messageApi.open({
                type: 'success',
                content: '邮箱验证码已发送，请注意查收',
              });
              timeCountDown()
            })
            .catch(err => {
              console.error(err)
              messageApi.open({
                type: 'error',
                content: err,
              });
            })
        })
        .catch((errorInfo) => {
          console.error('errorInfo', errorInfo)
        })
    } else {
      form.validateFields(['phone_number'])
        .then(async () => {
          await getPhoneVerifyCode({ phone_number: values.phone_number, country_code: '+86', code_type: 'reset' })
            .then(() => {
              messageApi.open({
                type: 'success',
                content: '手机验证码已发送，请注意查收',
              });
              timeCountDown()
            })
            .catch(err => {
              console.error(err)
              messageApi.open({
                type: 'error',
                content: err,
              });
            })
        })
        .catch((errorInfo) => {
          console.error('errorInfo', errorInfo)
        })
    }
  }

  // const renderContent = (
  //   <div className='register-qrcode-alert'>
  //       <span className='register-qrcode-title'>{'扫码添加客服'}</span>
  //       <span className='register-qrcode-text' style={{ marginBottom: '12px' }}>{'获取注册邀请码，解锁更多使用权益'}</span>
  //       <img className='register-qrcode-image' src={QR_CODE} alt="qr-code" />
  //   </div>
  // )

  const SECRET_INFO = 'https://mi8elatzm1x.feishu.cn/docx/PazXdOKmSordWGxxejLc2joqnIh?from=from_copylink';
  const USER_INFO = 'https://mi8elatzm1x.feishu.cn/docx/IyM2dSZKpovGFaxtws9ckeJFnSf?from=from_copylink';

  // const handleJumpUser = (e) => {
  //   e.stopPropagation();
  //   e.preventDefault();
  //   window.open(USER_INFO, '_blank');
  // }

  // const handleJumpSecret = (e) => {
  //   e.stopPropagation();
  //   e.preventDefault();
    
  //   window.open(SECRET_INFO, '_blank');
  // }

  // const handleForgetPassword = () => {
  //   propsSetIsLogin?.('forgetpassword');
  // }

  return (
    <>
      {contextHolder}
      <Form
          key={new Date().toDateString()}
          className="header-model-form"
          {...formItemLayout}
          form={form}
          variant={'filled'}
          size={'large'}
          initialValues={{
            email: '',
            password: '',
          }}
      >
        <Form.Item style={{ marginBottom: '24px' }}>
          <div className="header-model-form-item-title">
            <img style={{ width: '140px', height: '58px' }} src={LOGIN_LOGO} alt="login-logo" />
            <div className="header-model-form-item-title-text-container">
              <div className={`header-model-form-item-title-text ${isEmailLogin ? 'header-model-form-item-title-active' : ''}`}>
                <span
                  onClick={() => {
                    setLoginType('email')
                    setIsPassword(true)
                    form.setFieldsValue({
                      email: undefined,
                      phone_number: undefined,
                      password: undefined,
                    })
                  }}
                >
                  邮箱重置密码
                </span>
              </div>
              <div className="header-model-form-item-divider"></div>
              <div className={`header-model-form-item-title-text ${isPhoneLogin ? 'header-model-form-item-title-active' : ''}`}>
                <span
                  onClick={() => {
                    setLoginType('phone_number')
                    setIsPassword(true)
                    form.setFieldsValue({
                      email: undefined,
                      phone_number: undefined,
                      password: undefined,
                    })
                  }}
                >
                  手机号重置密码
                </span>
              </div>
            </div>
          </div>
        </Form.Item>
        {isEmailLogin ? (
          <>
          <Form.Item
          style={{ marginBottom: '12px' }}
          // label="Input"
          validateFirst
          name="email"
          rules={[
            {
              required: true,
              message: '请输入邮箱',
            },
            {
              pattern: /^[\w.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              message: '请输入正确的邮箱'
            }
          ]}
        >
          <Input style={{ height: '48px' }} placeholder='请输入邮箱' autoComplete="new-password" />
        </Form.Item>
        <Form.Item
          className="register-form-item-verify-code"
          // label="Input"
          name="verify_code"
          rules={[
            {
              required: true,
              message: '请输入验证码',
            },
            {
              len: 6,
              message: '请输入 6 位验证码'
            }
          ]}
        >
          <Space.Compact
            style={{
              width: '100%',
            }}
          >
            <Input placeholder='请输入验证码' autoComplete="new-password" />
            {countDown === 60
              ? <Button color="primary" variant="text" style={{ height: '48px' }} onClick={handleVerifyCode}>获取验证码</Button>
              : <Button color="primary" variant="text" style={{ height: '48px' }} disabled>{countDown + '(s)后再试'}</Button>}

          </Space.Compact>

        </Form.Item>
        </>
        ): null}
        {isPhoneLogin ? (
          <>
          <Form.Item
            style={{ marginBottom: '12px' }}
            // label="Input"
            validateFirst
            name="phone_number"
            rules={[
              {
                required: true,
                message: '请输入手机号',
              },
              {
                pattern: /^1[1-9]\d{9}$/,
                message: '请输入正确的手机号'
              }
            ]}
          >
            <Input style={{ height: '48px' }} placeholder='请输入手机号' autoComplete="new-password" />
          </Form.Item>
          <Form.Item
          className="register-form-item-verify-code"
          style={{ marginBottom: '12px' }}
          name="verify_code"
          rules={[
            {
              required: true,
              message: '请输入手机验证码',
            },
            {
              len: 6,
              message: '请输入6位手机验证码'
            }
          ]}
        >
          <Space.Compact
            style={{
              width: '100%',
            }}
          >
            <Input placeholder='请输入手机验证码' autoComplete="new-password" style={{ height: '48px' }} />
            {countDown === 60
                ? <Button color="primary" variant="text" style={{ height: '48px' }} onClick={handleVerifyCode}>获取验证码</Button>
                : <Button color="primary" variant="text" disabled style={{ height: '48px' }}>{countDown + '(s)后再试'}</Button>}
            
          </Space.Compact>
        </Form.Item>
          </>
        ) : null}

        <Form.Item
          style={{ marginBottom: '12px' }}
          // label="Password"
          name="password"
          validateFirst
          rules={[
            {
              required: true,
              message: '请输入密码',
            },
            {
              pattern: /^(?=.*\d)(?=.*[a-zA-Z]).*$/,
              message: '密码需要包含数字和英文'
            },
            {
              min: 8,
              message: '密码长度最少8个字符'
            },
            {
              max: 20,
              message: '密码长度不超过20个字符'
            },
          ]}
        >
          <Input.Password
            placeholder='请输入密码'
            autoComplete="new-password"
            style={{ height: '48px' }}
            iconRender={(visible) =>
              visible ? (
                <img className="password-icon" src={EyePng} alt="eye" />
              ) : (
                <img className="password-icon" src={HideEyePng} alt="hide-eye" />
              )}
            />
        </Form.Item>

        <div className="header-model-footer">
          <Button type="primary" block disabled={!submittable} onClick={handleLogin}>
            重置密码
          </Button>
          <Form.Item>
          {/* <Flex justify="end" align="center">
            <div>还没有账号？<a href="" style={{ color: '#376BFF' }} onClick={jumpRegister}>去注册</a></div>
          </Flex> */}
          </Form.Item>
          <div className="header-model-footer-sign" style={{ marginBottom: '10px' }}>
            <span style={{ color: '#888888' }}>重置密码成功？</span>
            <span style={{ borderBottom: '1px solid #376BFF' }}>
              <a href="" style={{ color: '#376BFF' }} onClick={jumpLogin}>去登录</a>
            </span>
          </div>
        </div>
      </Form>
    </>
  );
};

export default ForgetPassword;
